import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import { startLoading, endLoading } from '../../../actions/loadingAction';
import { translate, showMessageToastCustom, isNullOrEmpty } from '../../../utils/util';
import { ENUMS } from '../../../utils/constants';

const ConfirmationList = (props) => {
    const sendPrinter = (row) => {
        if (navigator.userAgent !== 'logisticspwa' && props.user.printer?.connectionType === ENUMS.ePrinterConnectionType.Bluetooth.value) {
            showMessageToastCustom(translate('general:warning'), translate('validations:service-not-available'), 3000, 'mdi mdi-alert-circle-outline red-text');
        } else {
            props.showLoading();
            props.sendToPrint({
                transmissionId: row.id,
                Id: row.receiptId,
                printer: props.user.printer,
                print: false
            }, props.user);
        }
    }

    const updateLabels = (item) => {
        var filter = {};
        filter.id = item.id
        props.updateLabels(filter, () => {
            props.getTransmission()
        });
    }

    const renderButtonDelete = (item) => {
        return (
            !item.success ? (
                <button
                    className="circle center btn-flat size-min-60"
                    type="button"
                    onClick={() => props.removeConfirmation(item.id, () => props.getTransmission())}
                >
                    <i className="material-icons red-text btn-circle-i">delete</i>
                </button>
            ) : (
                <button
                    className="circle center btn-flat size-min-60"
                    type="button"
                >
                    <i className="material-icons orange-text btn-circle-i">report_problem</i>
                </button>
            )
        );
    };

    const renderErrorLabel = (receipt) => {
        try {
            if (receipt && receipt.receiptStorages) {
                var erros = receipt.receiptStorages.filter(f => !isNullOrEmpty(f.error))

                if (erros.length > 0) {
                    return <div className="row" style={{ color: 'red' }}>
                        <small>
                            Info Etiqueta
                        </small>
                        {
                            erros.map((item) => (
                                <div key={item.id} className="col s10">
                                    <small>
                                        {item.error}
                                    </small>
                                </div>
                            ))
                        }
                    </div>
                }
            }
        } catch (error) {
            console.log(error);
        }

    }

    return (
        <div>
            <ul key={props.data.length} className="collection">
                {
                    props.data.map((item, index) => {
                        return (<li
                            key={index}
                            className="collection-item avatar z-depth-1"
                            style={{ backgroundColor: 'white', color: 'black' }}
                        >
                            {
                                (item.success && item.receipt.receiptStorages.filter(i => !i.printed).length > 0) ? (
                                    <button
                                        className="circle center btn-flat size-min-60"
                                        type="button"
                                        onClick={() => { sendPrinter(item) }}
                                    >
                                        <i className="material-icons orange-text btn-circle-i">report_problem</i>
                                    </button>
                                ) : renderButtonDelete(item)
                            }
                            {
                                !item.success && (
                                    <div className="title" style={{ float: 'right', margin: '5px' }}>
                                        <i className="material-icons green-text btn-circle-i" style={{ cursor: 'pointer' }} onClick={() => updateLabels(item)}>{'refresh'}</i>
                                    </div>
                                )
                            }
                            <span className="title black-text">{`${item.receipt.partNumberCode}`}</span>
                            <p>{item.receipt.partNumberDescription}</p>
                            <div>
                                <div className="col s6"><small>{`${translate('labels', 'general')}: ${item.boxQuantity}`}</small></div>
                                <div className="col s6"><small>{`${translate('parts', 'general')}: ${item.boxQuantityItems}`}</small></div>
                            </div>
                            {
                                item.message && (
                                    <div className="row">
                                        <div className="col s2">
                                            {
                                                !item.success && (
                                                    <i className="material-icons red-text" >
                                                        error_outline
                                                    </i>
                                                )}
                                        </div>
                                        <div className="col s10">
                                            <small>
                                                {item.message} {renderErrorLabel(item.receipt)}
                                            </small>
                                        </div>

                                    </div>
                                )
                            }
                            {
                                renderErrorLabel(item.receipt)
                            }
                        </li>);
                    })
                }
            </ul>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        removeConfirmation: (transmissionId, callback) => {
            dispatch(PhysicalConfirmationService.removeConfirmation(transmissionId, callback));
        },
        sendToPrint: (item, user) => {
            dispatch(PhysicalConfirmationService.sendToPrintInstantConfirmation(item, user.printer, () => {
                dispatch(endLoading());
            }));
        },
        updateLabels: (transmissionId, callback) => {
            dispatch(PhysicalConfirmationService.updateLabels(transmissionId, callback));
        },
        showLoading: () => {
            dispatch(startLoading());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ConfirmationList));

